import axios from '~/util/axios'

export default {
  shareAppBySms (phone, code, slug = 'share_app_sms') {
    const postData = {
      prospect: {
        phone: phone,
        sent_text: true,
        code: code
      },
      input: {
        phone_number: phone,
        access_code: code,
        message_slug: slug
      },
      code: code
    }
    return axios.post('/install/send_sms', postData)
  }
}
